import React from 'react';

/* ─────────────────────────────────────────────────────────
   CampNote Logo Icon
   - Pencil-on-notepad core mark
   - Teal + violet gradient — fresh campus energy
   - Star sparkle = knowledge  
───────────────────────────────────────────────────────── */
function CampNoteIcon({ size = 38 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      fill="none"
      role="img"
      aria-hidden="true"
    >
      <defs>
        <linearGradient id="cnBg" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#0ea5e9" />
          <stop offset="45%" stopColor="#6366f1" />
          <stop offset="100%" stopColor="#4f46e5" />
        </linearGradient>
        <linearGradient id="cnShine" x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" stopColor="#ffffff" stopOpacity="0.22" />
          <stop offset="100%" stopColor="#ffffff" stopOpacity="0" />
        </linearGradient>
        <filter id="cnDrop" x="-8%" y="-8%" width="124%" height="124%">
          <feDropShadow dx="0" dy="3" stdDeviation="5" floodColor="#4f46e5" floodOpacity="0.32" />
        </filter>
      </defs>

      {/* Rounded square background */}
      <rect x="2" y="2" width="60" height="60" rx="16" fill="url(#cnBg)" filter="url(#cnDrop)" />
      <rect x="2" y="2" width="60" height="32" rx="16" fill="url(#cnShine)" />

      {/* Notepad body */}
      <rect x="14" y="18" width="28" height="30" rx="3" fill="#ffffff" opacity="0.96" />

      {/* Notepad lines */}
      <line x1="19" y1="25" x2="36" y2="25" stroke="#c7d2fe" strokeWidth="2" strokeLinecap="round" />
      <line x1="19" y1="30" x2="36" y2="30" stroke="#c7d2fe" strokeWidth="2" strokeLinecap="round" />
      <line x1="19" y1="35" x2="30" y2="35" stroke="#c7d2fe" strokeWidth="2" strokeLinecap="round" />

      {/* Ring binding at top */}
      <rect x="22" y="14" width="12" height="7" rx="3.5" fill="#6366f1" />
      <rect x="24" y="13" width="8" height="4" rx="2" fill="#4f46e5" />

      {/* Pencil overlapping notepad — bottom-right */}
      <g transform="translate(34, 32) rotate(-40)">
        {/* Pencil body */}
        <rect x="0" y="0" width="7" height="18" rx="1.5" fill="#fbbf24" />
        {/* Eraser */}
        <rect x="0" y="0" width="7" height="4" rx="1.5" fill="#f87171" />
        {/* Pencil tip */}
        <polygon points="0,18 7,18 3.5,24" fill="#fde68a" />
        {/* Tip point */}
        <polygon points="1.5,22 5.5,22 3.5,24" fill="#1e293b" />
      </g>

      {/* Sparkle star — top right corner */}
      <g transform="translate(46, 10)">
        <path
          d="M5,0 L6.2,3.8 L10,5 L6.2,6.2 L5,10 L3.8,6.2 L0,5 L3.8,3.8 Z"
          fill="#fbbf24"
        />
      </g>
    </svg>
  );
}

export default function BrandLogo({ compact = false }) {
  return (
    <span className={`brand-logo ${compact ? 'compact' : ''}`}>
      <CampNoteIcon size={compact ? 30 : 38} />
      {!compact && (
        <span className="brand-wordmark">
          <span className="brand-wordmark-primary">Camp</span>
          <span className="brand-wordmark-accent">Note</span>
        </span>
      )}
    </span>
  );
}
